import { green, pink } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import FolderIcon from '@mui/icons-material/Folder';
import PageviewIcon from '@mui/icons-material/Pageview';
import AssignmentIcon from '@mui/icons-material/Assignment';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/colors": { green, pink }, "@mui/material/Avatar": Avatar, "@mui/material/Stack": Stack, "@mui/icons-material/Folder": FolderIcon, "@mui/icons-material/Pageview": PageviewIcon, "@mui/icons-material/Assignment": AssignmentIcon } } });
export default ClientProvider;
